import { render } from "./LegsCard.vue?vue&type=template&id=2095a3e5&scoped=true"
import script from "./LegsCard.vue?vue&type=script&lang=js"
export * from "./LegsCard.vue?vue&type=script&lang=js"

import "./LegsCard.vue?vue&type=style&index=0&id=2095a3e5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2095a3e5"]])

export default __exports__